import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SenderDetailsDomainTabContainer from './sender-details-tab-domains-container';
import SenderDetailsTabGeneral from './sender-details-tab-general';
import SenderDetailsTabProfileContainer from './sender-details-tab-profile-container';

import { fetchSender } from '../common/actions/senders-action-creators';
import { mySenderPaneDataSelector } from './selectors/sender-details-selectors';

export class SenderDetailsContentContainer extends Component{
    componentDidMount(){
        this.fetchData();
    }

    componentDidUpdate(){
        this.fetchData();
    }

    fetchData(){
        const { senderData } = this.props;
        this.props.fetchSender( senderData.senderId );
    }

    render(){
        const { senderData, tabIndex } = this.props;

        const tabContent = [
            <SenderDetailsTabProfileContainer senderData={senderData}/>,
            <SenderDetailsDomainTabContainer
                senderName={senderData.name}
                senderId={senderData.senderId}
            />,

            <SenderDetailsTabGeneral senderData={senderData} />
        ];

        return tabContent[tabIndex];
    }
}

SenderDetailsContentContainer.propTypes = {
    fetchSender: PropTypes.func.isRequired,
    senderData: PropTypes.object.isRequired,
    tabIndex: PropTypes.number.isRequired
};

const mapDispatchToProps = {
    fetchSender,
};

/* istanbul ignore next */
const mapStateToProps = state => ( {
    senderData: mySenderPaneDataSelector( state ),
} );

export default connect( mapStateToProps, mapDispatchToProps )( SenderDetailsContentContainer );
